module.exports = __webpack_public_path__ + "static/media/cloud-showers.8fc12767.svg";